

import React from 'react'
import { Route, Routes } from 'react-router-dom'
import SellerOrder from '../../components/SellerOrder/SellerOrder';
import SellerOrderView from '../../components/SellerOrder/SellerOrderView';
const SellerOrders = () => {
  return (
    <div className='w-full h-full'>
      <Routes>
        <Route path='view_orders' element={<SellerOrder/>}/>
        <Route path='view_order/:id' element={<SellerOrderView/>}/>

      </Routes>
    </div>
  )
}

export default SellerOrders